import React, { Component } from "react";
import ATable from "../common/table";
import Moment from "moment";
import Constants from "../../configurations/constants";
import RenderObjects from "../common/ObjectRenderer";
import Modal from "../common/modal";

class ReportProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedRow: null,
      ellipses: ""
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteDownload = this.deleteDownload.bind(this);
  }

  deleteDownload(row) {
    this.props.deleteDownload(row.index);
    clearInterval(this.interval[row.index]);
  }

  componentDidMount() {
    this.interval = [];
    this.ellipsesInterval = setInterval(this.updateEllipses, 500);
    if (this.props.reports && this.props.reports.length) {
      this.props.reports.forEach(
        (report, index) =>
          (this.interval[index] = setInterval(
            () => this.props.getReportStatus(report),
            5000
          ))
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reports.length && nextProps.reports.length > this.props.reports.length) {
      const nextReport = nextProps.reports[nextProps.reports.length - 1];
      this.interval[nextProps.reports.length - 1] = setInterval(
        () => this.props.getReportStatus(nextReport),
        5000
      );
    }
    nextProps.reports.forEach((report, index) => {
      if (
        report.status.toLowerCase() ===
        Constants.SETTLEMENT_REPORT_STATUS.COMPLETED ||
        report.status.toLowerCase() ===
        Constants.SETTLEMENT_REPORT_STATUS.FAILED
      ) {
        clearInterval(this.interval[index]);
      }
    });
  }

  componentWillUnmount() {
    this.interval.forEach(interval => clearInterval(interval));
    clearInterval(this.ellipsesInterval);
  }

  updateEllipses = () => {
    this.setState(prevState => {
      const newEllipses = prevState.ellipses.length >= 3 ? "" : prevState.ellipses + ".";
      return { ellipses: newEllipses };
    });
  };

  showModal(data) {
    this.setState({
      showModal: true,
      selectedRow: data
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
      selectedRow: null
    });
  }

  render() {
    const modalStyle = {
      overlay: {},
      content: {
        top: "80px",
        left: "250px",
        right: "250px",
        bottom: "180px",
        zIndex: "1000"
      }
    };

    const columns = [
      {
        header: "Search Criteria",
        render: row => {
          let searchCriteria;
          if (row.row.reportParams) {
            const reportObject = JSON.parse(row.row.reportParams);
            const { pageNum, pageSize, ...reportParams } = reportObject;
            searchCriteria = (
              <div onClick={() => this.showModal(reportParams)}>
                <a className="">View Criteria</a>
              </div>
            );
          }
          return searchCriteria;
        }
      },
      {
        header: "File Type",
        render: row => {
          let reportFormat;
          if (row.row.reportParams) {
            const reportParamObject = JSON.parse(row.row.reportParams);
            reportFormat =
              reportParamObject.reportFormat || reportParamObject.reportType;
          }
          return reportFormat;
        },
        width: 90
      },
      {
        header: "Status",
        accessor: "status",
        render: row => {
          return row.row.status;
        },
        width: 90
      },
      {
        header: "File name",
        accessor: "fileName",
        render: row => {
          return row.row.fileName
            ? row.row.fileName
            : "-- Report not available --";
        }
      },
      {
        header: "Created On",
        accessor: "createdOn",
        render: row => {
          return Moment(row.row.createdOn).format(Constants.DATE_FORMAT_LONG);
        }
      },
      {
        header: "",
        accessor: "action",
        render: row => {
          const status = row.row.status.toLowerCase();
          return (
            <div>
              {status === Constants.SETTLEMENT_REPORT_STATUS.COMPLETED ? (
                <button
                  className="btn-link"
                  onClick={() => {
                    this.props.download(row.row.fileName);
                  }}
                >
                  Download
                </button>
              ) : status === Constants.SETTLEMENT_REPORT_STATUS.FAILED ? (
                <button
                  className="btn-link"
                  onClick={() => {
                    this.props.retry(row.row);
                  }}
                >
                  Retry
                </button>
              ) : (
                <span className="text-info">
                  Generating Report{this.state.ellipses}
                </span>
              )}
            </div>
          );
        }
      },
      {
        header: "",
        render: row => (
          <button
            className="btn-link"
            onClick={() => this.deleteDownload(row)}
          >
            Remove
          </button>
        )
      }
    ];

    const { reports, clearDownloads } = this.props;
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <div className="row">
            <div className="col-sm-6">
              <h4 className="bold">Reports progress</h4>
            </div>
            <div className="col-sm-6 text-right">
              <button
                className="btn btn-sm btn-danger"
                onClick={clearDownloads}
              >
                Close
              </button>
            </div>
          </div>

          <ATable
            className="-striped -highlight"
            tableData={reports}
            columns={columns}
            defaultPageSize={reports.length < 5 ? reports.length : 5}
            showPagination={reports.length > 5}
            pageSize={reports.length < 5 ? reports.length : 5}
            showPageSizeOptions={false}
            {...this.props}
          />
          <Modal
            title="Report parameters"
            isOpen={this.state.showModal}
            onRequestClose={this.closeModal}
            style={modalStyle}
          >
            <RenderObjects
              className="dispute-col"
              objectToConv={this.state.selectedRow}
            />
          </Modal>
        </div>
      </div>
    );
  }
}

export default ReportProgress;



// WEBPACK FOOTER //
// ./src/components/reports/ReportProgress.js